export default __webpack_public_path__ + "static/media/LO11a.296781d7.mp3";